var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-screen h-screen p-4 pt-2 pb-2 sm:p-8 sm-24 lg:p-32 bg-white",attrs:{"id":"app"}},[_c('div',{staticClass:"w-full h-full flex flex-col"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }